import { adminRoutes } from '@common/routes';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { MenuGrow } from '~/@components/MenuGrow';
import { PROJECT_VIEW_MODE } from '~/@store/projects';
import { projectsStore } from '~/@store/projects/project.store';
import i18n from '~/i18n';

interface IViewModeOption {
    value: PROJECT_VIEW_MODE;
    title: string;
    path: string;
}

export const VIEW_MODE_OPTIONS: IViewModeOption[] = [
    {
        value: PROJECT_VIEW_MODE.ALL_PROJECTS,
        title: i18n.Admin.projectsPage.allProjects,
        path: adminRoutes.allProjects,
    },
    {
        value: PROJECT_VIEW_MODE.ACTIVE_PROJECTS,
        title: i18n.Admin.projectsPage.activeProjects,
        path: adminRoutes.activeProjects,
    },
];

const renderValue = (viewModeOption: IViewModeOption) => viewModeOption.title;

export const ProjectViewModeSelect: React.FC = observer(() => {
    const history = useHistory();
    const viewMode = projectsStore.viewMode;

    const handleChange = useCallback((viewModeOption: IViewModeOption) => history.push(viewModeOption.path), [history]);

    const value = VIEW_MODE_OPTIONS.find(m => m.value === viewMode);

    return (
        <MenuGrow<IViewModeOption>
            value={value}
            onChange={handleChange}
            items={VIEW_MODE_OPTIONS}
            renderValue={renderValue}
        />
    );
});
